import script from "./TeamMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberModal.vue?vue&type=script&setup=true&lang=js"

import "./TeamMemberModal.vue?vue&type=style&index=0&id=f0572cc2&lang=css"

const __exports__ = script;

export default __exports__